const lazyPageComponent = () => import('@/Pages/Ru/ItActivity.vue');

export const itActivityRoutes = [
  {
    path: '/it-activity',
    pathname: '/it-activity',
    name: 'it-activity',
    component: lazyPageComponent,
    meta: {
      name: 'it-activity',
    },
  },
];
